<template>
  <base-dialog :visible.sync="visible" class="settingDialog">
    <template #header>{{ title }}</template>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入模板名称"></el-input>
      </el-form-item>
      <el-form-item v-if="title === '创建'" label="工作表" prop="sheetId">
        <el-select v-model="form.sheetId" placeholder="请选择工作表" filterable style="width: 100%">
          <el-option
            v-for="sheet in canSelectSheetList"
            :key="sheet.sheetId"
            :label="sheet.name"
            :value="sheet.sheetId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="模板文件" prop="templateFile">
        <el-button
          v-if="!form.templateFile"
          size="small"
          type="primary"
          @click="openAllFiles(form.templateFile && form.templateFile.id)"
        >
          + 选择模板文件
        </el-button>
        <div v-else>
          <el-tag effect="dark" type="success">
            {{ form.templateFile.name }}
          </el-tag>
          <span
            class="change-file"
            @click="openAllFiles(form.templateFile && form.templateFile.id)"
          >
            更改文件
          </span>
        </div>
      </el-form-item>
      <el-form-item label="模板描述" prop="desc">
        <el-input
          v-model="form.desc"
          :autosize="{ minRows: 2, maxRows: 6 }"
          type="textarea"
          resize="none"
          placeholder="请添加模板描述"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="print-setting scroll">
      <div class="title">打印列设置</div>
      <div v-if="printCols.length > 0" class="list">
        <el-row :gutter="20">
          <el-col :span="8" class="tip">
            列序号
            <el-tooltip effect="dark" placement="bottom">
              <div slot="content">Excel 表格顶部的列序号（如A——Z，AA——AZ等）</div>
              <i class="el-icon-question icon-tip"></i>
            </el-tooltip>
          </el-col>
          <el-col :span="16">打印元素</el-col>
        </el-row>
        <el-row v-for="(item, index) in printCols" :key="index" :gutter="20">
          <el-col :span="8">
            <el-input v-model="item.rowNum"></el-input>
          </el-col>
          <el-col :span="15">
            <el-select
              v-model="item.value"
              placeholder="请选择"
              no-data-text="请设置过工作表后再选择"
              filterable
            >
              <el-option-group
                v-for="(group, index) in canPrintFields"
                :key="index"
                :label="group.label"
              >
                <el-option
                  v-for="item in group.options"
                  :key="item._cid"
                  :label="item.name"
                  :value="item._cid"
                ></el-option>
              </el-option-group>
            </el-select>
          </el-col>
          <i class="el-icon-delete-solid icon-delete" @click="delPrintCol(index)"></i>
        </el-row>
      </div>
      <div class="addConditionBtn" @click="addPrintCol">
        添加打印列
      </div>
    </div>
    <template #footer>
      <el-button @click="visible = false">取 消</el-button>
      <el-button v-if="title == '创建'" type="primary" @click="saveTemplate">
        创 建
      </el-button>
      <el-button v-else-if="title == '编辑'" type="primary" @click="saveTemplate">
        编 辑
      </el-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/UIComponents/BaseDialog.vue"

export default {
  name: "ExcelTplDialog",
  components: { BaseDialog },
  inject: ["app"],
  props: {
    initialExcelTpl: Object,
    availableSheetsMap: Object
  },
  data() {
    return {
      form: {},
      rules: {
        name: [{ required: true, message: "请输入模板名称", trigger: "blur" }],
        sheetId: [{ required: true, message: "请选择工作表", trigger: "change" }],
        templateFile: [{ required: true, message: "请选择模板文件", trigger: "change" }]
      },
      printCols: [],
      title: "",
      visible: false
    }
  },
  computed: {
    canSelectSheetList() {
      return Object.values(this.availableSheetsMap).filter(sheet => sheet.appId === this.app.id)
    },
    // 可以选择打印的字段
    canPrintFields() {
      if (!this.form.sheetId || Object.keys(this.availableSheetsMap).length == 0) return []
      let canPrintFields = []
      let sheetFields = []
      this.availableSheetsMap[this.form.sheetId]?.controls.forEach(i => {
        sheetFields.push({ _cid: i._cid, name: i.name })
        // 工作表单条关联数据
        if (i._type == "ref" && i.oneFlag) {
          if (i.fields.length != 0) {
            let refSheet = this.availableSheetsMap[i.refSheetId]
            let refSheetFieldsMap = refSheet.controls.reduce((acc, cur) => {
              acc[cur._cid] = cur.name
              return acc
            }, {})
            let options = i.fields.map(cid => ({
              _cid: i._cid + "." + cid,
              name: refSheetFieldsMap[cid]
            }))
            canPrintFields.push({ label: "关联" + refSheet.name, options })
          }
        }
      })
      canPrintFields.unshift(
        {
          label: "系统变量",
          options: [{ _cid: "id", name: "自增序号" }]
        },
        {
          label: this.availableSheetsMap[this.form.sheetId]?.name,
          options: sheetFields
        }
      )
      return canPrintFields
    }
  },
  methods: {
    // Dialog 打开的回调
    open(initialExcelTpl) {
      this.form = {}
      this.printCols = []
      this.visible = true
      if (initialExcelTpl) {
        // 编辑时要设置初始信息
        this.form = {
          id: initialExcelTpl.id,
          name: initialExcelTpl.name,
          sheetId: initialExcelTpl.sheetId,
          desc: initialExcelTpl.desc,
          templateFile: initialExcelTpl.file
        }
        this.printCols = initialExcelTpl.colDefList.reduce((acc, cur, index) => {
          if (!cur) return acc
          let char = []
          if (index >= 26) {
            char[0] = (index + 1) / 26 + 64
            char[1] = ((index + 1) % 26) + 64
          } else char[0] = index + 1 + 64
          acc.push({
            rowNum: String.fromCodePoint(...char),
            value: cur
          })
          return acc
        }, [])
        this.title = "编辑"
      } else {
        this.title = "创建"
      }
    },
    // 打开选择文件弹窗
    openAllFiles(fileId) {
      this.$emit("openAllFiles", fileId)
    },
    // 选择文件
    selectFile(file) {
      this.$set(this.form, "templateFile", file)
      this.$nextTick(() => {
        this.$refs["form"].validateField("templateFile")
      })
    },
    // 添加打印列
    addPrintCol() {
      let { result, msg } = this.colsCheck("add")
      if (!result) {
        this.$message.warning({
          message: msg,
          offset: 200
        })
        return
      }
      this.printCols.push({
        rowNum: "",
        value: ""
      })
      this.$nextTick(() => {
        this.scrollToBottom()
      })
    },
    // 滚动到 .print-setting.scroll 底部
    scrollToBottom() {
      if (this.printCols.length > 0) {
        document.querySelector(".print-setting.scroll").scrollIntoView({
          block: "end",
          behavior: "smooth"
        })
      }
    },
    // 删除打印列
    delPrintCol(index) {
      this.printCols.splice(index, 1)
    },
    // 检查打印列是否填写完整
    colsCheck(from) {
      let msg
      if (from == "submit") msg = "请将已添加的打印列填写完整后再提交"
      else if (from == "add") msg = "请将已添加的打印列填写完整后再添加"
      for (let item of this.printCols) {
        if (!item.rowNum || !item.value) {
          return {
            result: false,
            msg
          }
        }
      }
      return {
        result: true,
        msg: ""
      }
    },
    // 检查打印列序号填写是否正确
    resolveRowNum() {
      let temp = new Set(this.printCols.map(i => i.rowNum))
      if (temp.size != this.printCols.length) {
        this.$message.error({
          message: `打印列设置存在重复的列序号，请修改后再提交`,
          offset: 200,
          duration: 4000
        })
        return false
      }
      for (let [index, item] of this.printCols.entries()) {
        if (item.rowNum.length > 2 || !/^[A-Z]{1,2}$/.test(item.rowNum)) {
          this.$message.error({
            message: `打印列设置的第${index + 1}项的列序号[${item.rowNum}]填写错误，请修改后再提交`,
            offset: 200,
            duration: 4000
          })
          return false
        }
        // 将列序号转成数字
        item.rowIndex = Array.from(item.rowNum).reduce((acc, cur, index) => {
          let count = 0
          // 转成ASCII码后计算
          if (index == 0 && item.rowNum.length == 2) count = (cur.charCodeAt() - 64) * 26
          else count = cur.charCodeAt() - 64
          return (acc += count)
        }, 0)
      }
      return true
    },
    // 获取提交的数据
    getSubmitData() {
      let colDefList = []
      this.printCols.forEach(i => (colDefList[i.rowIndex - 1] = i.value))
      let submitData = {
        id: this.form.id,
        name: this.form.name,
        sheetId: this.form.sheetId,
        desc: this.form.desc,
        colDefList,
        file: {
          id: this.form.templateFile.id
        }
      }
      return submitData
    },
    // 创建 或 编辑 Excel 导出模板
    saveTemplate() {
      this.$refs["form"].validate(valid => {
        if (!valid) return false
        let { result, msg } = this.colsCheck("submit")
        if (!result)
          return this.$message.warning({
            message: msg,
            offset: 200
          })
        if (!this.resolveRowNum()) return
        let excelTemplate = this.getSubmitData()
        if (this.title == "创建") this.$emit("createTemplate", excelTemplate)
        else if (this.title == "编辑") this.$emit("editTemplate", excelTemplate)
        this.visible = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.settingDialog {
  .print-setting {
    color: #606266;
    .title {
      font-weight: bold;
    }
    .addConditionBtn {
      margin-top: 15px;
      padding: 0 12px;
      height: 36px;
      line-height: 36px;
      background: #f5f5f5;
      cursor: pointer;
      color: #1e88e5;
      &:hover {
        color: #1565c0;
      }
    }
    .list {
      margin-top: 10px;
      margin-left: 12px;
      .el-row {
        &:hover {
          .icon-delete {
            display: block;
          }
        }
        .icon-delete {
          position: absolute;
          right: 8px;
          top: 20px;
          cursor: pointer;
          color: #bdbdbd;
          display: none;
          &:hover {
            color: #1e88e5;
          }
        }
        .el-col {
          margin-top: 10px;
          .el-input,
          .el-select {
            width: 100%;
          }
          .icon-tip {
            color: #9e9e9e;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
